import React, { useEffect, useState } from 'react'
import Title from '../Title/Title'
import Nav from '../Nav/Nav'
import Select from 'react-select'
import { connect, useSelector, useDispatch } from 'react-redux'
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet'
import DropdownLayers from '../Select/DropdownLayers'
import { styleRegistry, styleRegistryLines } from '../../leaflet/colorRamps'
import 'leaflet/dist/leaflet.css'
import './Matadepera.css'
import {geo} from "@observablehq/plot";

const position = [41.61145296899627, 2.012341960276202]

const defaultStyle = ({
    weight: 2,
    opacity: 1,
    color: 'none',  // Outline color
    fillOpacity: 1
})

const baseMaps =  [
    { value: 'https://b.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', label: 'cartodb'},
    { value: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/orto/MON3857NW/{z}/{x}/{y}.png', label: 'ortogràfic' },
    { value: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/administratiu/MON3857NW/{z}/{x}/{y}.png', label: 'administratiu'},
    { value: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic/MON3857NW/{z}/{x}/{y}.png', label: 'topogràfic'},
    { value: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/topografic-gris/MON3857NW/{z}/{x}/{y}.png', label: 'topogràfic gris'},
    { value: 'https://geoserveis.icgc.cat/servei/catalunya/mapa-base/wmts/simplificat/MON3857NW/{z}/{x}/{y}.png', label: 'simplificat'}
]


const Matadepera = props => {
    const dispatch = useDispatch()
    const { layersDispatch } = props
    const [loading, setLoading] = useState(true)
    const [activeBaseMap, setBaseMap] = useState(baseMaps[0])
    const { view, visibleVectors } = layersDispatch
    const peinData = useSelector(state => state.layers.pein )
    const geoData = useSelector(state => state.layers.layers )
    const streetData = useSelector(state => state.layers.streets)
    const sectionData = useSelector(state => state.layers.sections)
    const facilityData = useSelector( state => state.layers.facilities )
    const neighborhoodData = useSelector(state => state.layers.neighborhoods)
    //const [geoData, setGeoData] = useState([{}])
    const onClick = obj => {
        setBaseMap(obj)
    }
    const customStyles = {
        control: (baseStyles, state) => ({
            ...baseStyles,
            backgroundColor: 'white',
            borderColor: 'white',
            // minHeight: '34px',
            // height: '34px'
        }),
        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            fontSize: '11px', // Smaller text while typing
        }),
        option: (base) => ({
            ...base,
            fontSize: '13px', // Smaller text in the dropdown list
            padding: '4px 10px', // Thinner rows in the dropdown
        }),
        valueContainer: (base) => ({
            ...base,
            height: 25,
            padding: '0px 5px', // Tighten the horizontal padding
            fontSize: '13px', // Smaller text for the selected value
        }),
    }
    useEffect(() => {
        const response = dispatch.layers.loadDatabaseLayer({ view: 'indice_dependencia'})
        const { layers } = response
        setLoading(false)
    },[dispatch])
    const geoJsonStyle = feature => {
        if (!view) { return defaultStyle}
       return styleRegistry[view](feature) || defaultStyle
    }
    const geoJsonStyleLines = feature => {
        if (!view) { return defaultStyle }
        if (!styleRegistryLines[view]) {
            return defaultStyle
        }
        return styleRegistryLines[view](feature) || defaultStyle
    }
    const geoJsonDefaultPolygons = feature => {
       return styleRegistryLines['default'](feature) || defaultStyle
    }
    const geoJsonStylePEIN = feature => {
        return styleRegistryLines['pein'](feature) || defaultStyle
    }
    return (
        <div className='main-page' style={{gridTemplateRows: 'repeat(40, 50px)',  gridColumn: '1 / 12'}}>
            <div className='container title-container matadepera'>
                <img src='./images/portfolio/logo.png' width='50px' style={{ float: 'left' }}/>
                <h1>Indice Integrado de Calidad Urbana (IICU) para Matadepera</h1>
            </div>
            <Nav/>
            <DropdownLayers optionsMulti={[  { value: 'streets', label: 'calles', endpoint: 'streets' },
                { value: 'parcels', label: 'parcelas', endpoint:  'indices_pob' },
                { value: 'neighborhoods', label: 'barrios', endpoint: 'neighborhoods' },
                { value: 'sections', label: 'secciones', endpoint: 'sections' },
                { value: 'facilities', label: 'equipamientos', endpoint: 'facilities'},
                { value: 'pein', label: 'espacio pein', endpoint: 'pein'},
                { value: 'ndvi', label: 'ndvi', endpoint: 'ndvi'},

            ]}/>
            <div className='selection basemap header'>
                <h6>Selecció de basemap:</h6>
            </div>
            <div className='select basemap'>
                    <Select
                        options={ baseMaps }
                        onChange={ onClick }
                        defaultValue={ baseMaps[0] }
                        styles={ customStyles }
                    />
            </div>
            <MapContainer
                    center={position}
                    zoom={14.3}
                    style={{ gridColumn: '4 / 12', gridRow: '4 / 25' }}
                >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        key={ activeBaseMap.value }
                        url={ activeBaseMap.value }
                    />
                {
                    loading ? <p>Loading...</p> :
                        <>
                        { visibleVectors.parcels && <GeoJSON
                                key={JSON.stringify(geoData)}
                                data={geoData}
                                style={geoJsonStyle}
                                onEachFeature={(feature, layer) => {
                                    if (feature.properties) {
                                        const entries = Object.entries(feature.properties).filter(row => row[0] !== 'st_asgeojson' )
                                        const popupContent = entries
                                            .map(([key, value]) => `<b>${key}:</b> ${value}`)
                                            .join("<br/>");

                                        layer.bindPopup(popupContent);
                                    }
                                }}
                            /> }
                            { visibleVectors.streets && <GeoJSON
                                data={streetData}
                                key={JSON.stringify(streetData)}
                                style={geoJsonStyleLines}
                                onEachFeature={(feature, layer) => {
                                    if (feature.properties) {
                                        const entries = Object.entries(feature.properties).filter(row => row[0] !== 'st_asgeojson' )
                                        const popupContent = entries
                                            .map(([key, value]) => `<b>${key}:</b> ${value}`)
                                            .join("<br/>");
                                        layer.bindPopup(popupContent);
                                    }
                                }}
                            /> }
                        { visibleVectors.neighborhoods && <GeoJSON
                                data={neighborhoodData}
                                key={JSON.stringify(neighborhoodData)}
                                style={geoJsonDefaultPolygons}
                                onEachFeature={(feature, layer) => {
                                    if (feature.properties) {
                                        const entries = Object.entries(feature.properties).filter(row => row[0] !== 'st_asgeojson' )
                                        const popupContent = entries
                                            .map(([key, value]) => `<b>${key}:</b> ${value}`)
                                            .join("<br/>");
                                        layer.bindPopup(popupContent);
                                    }
                                }}
                            /> }
                        {  visibleVectors.sections && <GeoJSON
                                data={sectionData}
                                key={JSON.stringify(sectionData)}
                                style={geoJsonDefaultPolygons}
                                onEachFeature={(feature, layer) => {
                                    if (feature.properties) {
                                        const entries = Object.entries(feature.properties).filter(row => row[0] !== 'st_asgeojson')
                                        const popupContent = entries
                                            .map(([key, value]) => `<b>${key}:</b> ${value}`)
                                            .join("<br/>");

                                        layer.bindPopup(popupContent);
                                    }
                                }}
                            />}
                        {  visibleVectors.facilities && <GeoJSON
                            data={facilityData}
                            key={JSON.stringify(facilityData)}
                            style={geoJsonDefaultPolygons}
                            onEachFeature={(feature, layer) => {
                                if (feature.properties) {
                                    const entries = Object.entries(feature.properties).filter(row => row[0] !== 'st_asgeojson')
                                    const popupContent = entries
                                        .map(([key, value]) => `<b>${key}:</b> ${value}`)
                                        .join("<br/>");

                                    layer.bindPopup(popupContent);
                                }
                            }}
                        />}
                        {  visibleVectors.pein && <GeoJSON
                            data={peinData}
                            key={JSON.stringify(peinData)}
                            style={geoJsonStylePEIN}
                            onEachFeature={(feature, layer) => {
                                if (feature.properties) {
                                    const entries = Object.entries(feature.properties).filter(row => row[0] !== 'st_asgeojson')
                                    const popupContent = entries
                                        .map(([key, value]) => `<b>${key}:</b> ${value}`)
                                        .join("<br/>");

                                    layer.bindPopup(popupContent);
                                }
                            }}
                        />}
                        </>
                }
                </MapContainer>
        </div>
    )
}

const mapStateToProps = () => (
    dispatch => ({
        layersDispatch: dispatch.layers
    })
)

export default connect(mapStateToProps)(Matadepera)
